import React, { useContext, useEffect, useCallback } from 'react';
import { Box, Menu, MenuItem } from '@mui/material';
import RoomRoundedIcon from '@mui/icons-material/RoomRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { isUndefined } from 'lodash';
import { DataContext } from '../../context/DataContext';
import { getToken } from '../../api/Account';
import { getSucursalByUserAsync } from '../../api/Users';

// Selector global de sucursal en el topbar — ver design_handoff_crediapp_redesign/README.md (SucursalSelector).
// Sustituye a los selectores locales que cada pantalla implementaba por su cuenta.
const SucursalSelector = () => {
	const { selectedSucursal, setSelectedSucursal, sucursales, setSucursales } = useContext(DataContext);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const token = getToken();

	const loadSucursales = useCallback(async () => {
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			return;
		}
		const list = result.data.result || [];
		setSucursales(list);
		if ((selectedSucursal === 0 || isUndefined(selectedSucursal)) && list.length > 0) {
			setSelectedSucursal(list[0].id);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);

	useEffect(() => {
		loadSucursales();
	}, [loadSucursales]);

	if (sucursales.length === 0) {
		return null;
	}

	const activa = sucursales.find((s) => s.id === selectedSucursal);

	return (
		<>
			<Box
				onClick={(e) => setAnchorEl(e.currentTarget)}
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '8px',
					height: '42px',
					padding: '0 15px',
					borderRadius: '11px',
					backgroundColor: 'action.hover',
					border: '1px solid',
					borderColor: 'divider',
					color: 'text.primary',
					fontWeight: 700,
					fontSize: '13.5px',
					cursor: 'pointer',
					whiteSpace: 'nowrap'
				}}
			>
				<RoomRoundedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
				Sucursal: {activa ? activa.description : ''}
				<KeyboardArrowDownRoundedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
			</Box>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				PaperProps={{ sx: { borderRadius: '12px', minWidth: 220, marginTop: '8px' } }}
			>
				{sucursales.map((s) => (
					<MenuItem
						key={s.id}
						selected={s.id === selectedSucursal}
						onClick={() => {
							setSelectedSucursal(s.id);
							setAnchorEl(null);
						}}
						sx={{ display: 'flex', gap: '10px', fontSize: 14, fontWeight: 700 }}
					>
						<RoomRoundedIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
						<Box component="span" sx={{ flex: 1 }}>
							{s.description}
						</Box>
						{s.id === selectedSucursal ? <CheckRoundedIcon sx={{ fontSize: 18, color: 'success.main' }} /> : null}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default SucursalSelector;
